<template>
  <div id="alterations">
    <div class="header-text">
      <h1>密码找回</h1>
    </div>

    <div>
      <el-card shadow="never" class="centercard">
        <div class="centercardForm">
          <el-form
            :model="Password"
            :rules="PasswordRules"
            ref="PasswordRef"
            label-width="100px"
            class="demo-ruleForm"
            size="small"
            :label-position="labelPosition"
          >
            <el-form-item label="手机号" prop="mobile">
              <el-input
                placeholder="请输入手机号"
                v-model="Password.mobile"
              ></el-input>
            </el-form-item>
            <el-form-item label="员工编号" prop="empCode">
              <el-input
                placeholder="请输入员工编号"
                v-model="Password.empCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="verityCode">
              <div class="flex-between">
                <el-input
                  placeholder="请输入验证码"
                  v-model="Password.verityCode"
                ></el-input>
                <!-- 获取验证码按钮 -->
                <el-button
                  v-if="disabled"
                  size="mini"
                  style="margin-left: 5%"
                  @click="verification('PasswordRef')"
                  >获取验证码</el-button
                >
                <el-button
                  v-if="!disabled"
                  type="info"
                  disabled
                  size="mini"
                  style="margin-left: 5%"
                  >{{ timer }}秒后重试</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
              <el-input
                placeholder="请输入重置密码"
                show-password
                v-model="Password.newPwd"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPwd">
              <el-input
                placeholder="请确认重置密码"
                show-password
                v-model="Password.confirmPwd"
              ></el-input>
            </el-form-item>

            <el-button
              style="width: 36%; margin-left: 30%"
              @click="resetpassword('PasswordRef')"
              >重置密码</el-button
            >
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { VerificationCodeApi, SysempresetPwdApi } from "@/api/user";
export default {
  name: "alterations",
  data() {
    return {
      // 获取验证码按钮
      disabled: true,
      timer: 60,

      labelPosition: "left",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      Password: {
        mobile: "", //手机号
        empCode: "", //员工编号
        verityCode: "", //验证码
        newPwd: "", //新密码
        confirmPwd: "", // 确认新密码
      },
      PasswordRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        empCode: [
          { required: true, message: "请输入员工编号", trigger: "change" },
        ],
        verityCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
          { pattern: /^\d{1,}$/, message: "验证码格式不正确", trigger: "blur" },
        ],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "change" },
          {
            pattern:
              /^([`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]|[A-Za-z0-9])+$/,
            message: "密码格式不正确",
            trigger: "blur",
          },
        ],
        confirmPwd: [
          { required: true, message: "请输入确认新密码", trigger: "change" },
          {
            pattern:
              /^([`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]|[A-Za-z0-9])+$/,
            message: "确认密码格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 获取验证码
    verification(PasswordRef) {
      this.$refs[PasswordRef].validateField("mobile", (mobileError) => {
        if (!mobileError) {
          this.disabled = false;
          this.getVerification(); // 调获取验证码接口
          const authTimer = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
              this.disabled = true;
              this.timer = 60;
              clearInterval(authTimer);
            }
          }, 1000);
        } else {
          return false;
        }
      });
    },
    // 获取验证码请求
    getVerification() {
      let data = {
        phone: this.Password.mobile,
      };
      VerificationCodeApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("获取验证码失败!");
          return;
        } else {
          this.$message.success("获取验证码成功,请查收!");
        }
      });
    },
    // 重置密码
    resetpassword(PasswordRef) {
      this.$refs[PasswordRef].validate(async (valid) => {
        if (!valid) return;
        SysempresetPwdApi(this.Password).then((res) => {
          if (res.success !== true) {
            this.$message.error("重置密码失败!");
            return;
          } else {
            this.$message.success("重置密码成功!");
            this.$refs.PasswordRef.resetFields();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

.centercard {
  margin-top: 10px;
}
.centercardForm {
  width: 500px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
</style>
